import React, { useState } from "react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";

import ArticleIcon from "@mui/icons-material/Article";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import ModalProtocolsBrands from "../ModalProtocolsBrands";

const ProcessDispatches = ({ dispatches }) => {
  const [openProtocoloId, setOpenProtocoloId] = useState(null);

  return (
    <Box
      sx={{
        width: "100%",
        p: 4,
        background: "#f0f0f0",
        borderRadius: 2,
      }}
    >
      <Typography variant="h6" fontWeight={600}>
        Despachos
      </Typography>
      <List
        sx={{
          my: 2,
        }}
      >
        {dispatches?.length > 0 ? (
          dispatches.map((dispatche) => (
            <>
              <ListItem
                secondaryAction={
                  <IconButton
                    edge="end"
                    aria-label="acoes-despachos"
                    onClick={() => setOpenProtocoloId(dispatche.id)}
                  >
                    <Tooltip title="Ver protocolos">
                      <FindInPageIcon />
                    </Tooltip>
                  </IconButton>
                }
              >
                <ListItemAvatar>
                  <Avatar>
                    <ArticleIcon />
                  </Avatar>
                </ListItemAvatar>
                <Tooltip
                  sx={{ cursor: "pointer" }}
                  title={dispatche?.texto_complementar}
                >
                  <ListItemText
                    primary={`Código: ${dispatche?.codigo}`}
                    secondary={
                      <>
                        <span>{dispatche?.nome}</span>
                        {dispatche?.data && (
                          <span style={{ marginLeft: 8, color: "#888", fontSize: "0.8em" }}>
                            {new Date(dispatche.data).toLocaleDateString("pt-BR")}
                          </span>
                        )}
                      </>
                    }
                  />
                </Tooltip>
              </ListItem>
              <ModalProtocolsBrands
                open={openProtocoloId === dispatche.id}
                handleClose={() => setOpenProtocoloId(null)}
                protocols={dispatche?.protocolo_despacho}
              />
              <Divider />
            </>
          ))
        ) : (
          <ListItem>Nenhum despacho.</ListItem>
        )}
      </List>
    </Box>
  );
};

export default ProcessDispatches;
